import p5 from 'p5'

export default class Marquee {
  static init() {
    const breakpoints = {
      xxlarge: 2460,
      xlarge: 1980,
      large: 1440,
      medium: 1024,
      small: 768,
      xsmall: 525,
      tiny: 425,
    }

    let canvasContainer
    let manifest = 'OLTRANZA FESTIVAL'

    let textY = 0
    let lineHeight
    let bgColor = '#10C870'
    let textColor = '#1D1D1B'

    let globalFontSize
    let textSpacing
    let myFont

    const viewportWidth = window.innerWidth

    // Determine the appropriate font size based on breakpoints
    if (viewportWidth >= breakpoints.xxlarge) {
      globalFontSize = 230
      textSpacing = 30
    } else if (viewportWidth >= breakpoints.xlarge) {
      globalFontSize = 180
      textSpacing = 24
    } else if (viewportWidth >= breakpoints.large) {
      globalFontSize = 144
      textSpacing = 20
    } else if (viewportWidth >= breakpoints.medium) {
      globalFontSize = 90
      textSpacing = 18
    } else if (viewportWidth >= breakpoints.small) {
      globalFontSize = 70
      textSpacing = 15
    } else if (viewportWidth >= breakpoints.xsmall) {
      globalFontSize = 50
      textSpacing = 5
    } else {
      globalFontSize = 50
      textSpacing = 5
    }

    const sketch = (p) => {
      p.preload = () => {
        myFont = p.loadFont(
          'assets/fonts/TuskerGrotesk/TuskerGrotesk-4800Super.otf'
        )
      }

      p.setup = () => {
        canvasContainer = document.querySelector('.marquee-canvas-container')

        const containerWidth = canvasContainer.offsetWidth
        const containerHeight = canvasContainer.offsetHeight

        p.createCanvas(containerWidth, containerHeight, p.P2D).parent(
          canvasContainer
        )

        p.textSize(globalFontSize)
        p.textFont(myFont)
        p.textStyle(p.BOLD)
        p.textAlign(p.LEFT, p.TOP)
        lineHeight = p.textAscent() + p.textDescent()
        p.frameRate(60)

        drawTextGrid()
      }

      function calculateTextWidth(fontSize, text) {
        const tempCanvas = document.createElement('canvas')
        const tempContext = tempCanvas.getContext('2d')
        tempContext.font = `${p.BOLD} ${fontSize}px Tusker Grotesk`
        return tempContext.measureText(text).width
      }

      function drawTextGrid() {
        const fontSize = globalFontSize
        const textWidth = calculateTextWidth(fontSize, manifest)

        // Calculate the number of rows and columns
        const rows = Math.ceil(p.height / lineHeight)
        const cols = Math.ceil(p.width / (textWidth + textSpacing))

        // Calculate the fractional part of textY
        const fractionalPart = textY % lineHeight

        // Loop to fill the canvas with text horizontally and vertically
        for (let i = -1; i < rows + 1; i++) {
          for (let j = 0; j < cols; j++) {
            const x = j * (textWidth + textSpacing)
            const y = i * lineHeight + fractionalPart
            p.fill(textColor)
            p.text(manifest, x, y)
          }
        }
      }

      function updateTextPosition() {
        textY -= 0.25
        if (textY <= -lineHeight) {
          textY = 0
        }
      }

      p.draw = () => {
        p.background(bgColor)
        drawTextGrid()
        updateTextPosition()
      }

      p.windowResized = () => {
        p.resizeCanvas(p.windowWidth, p.windowHeight)
        p.textSize(globalFontSize)
        lineHeight = p.textAscent() + p.textDescent()
        drawTextGrid()
      }
    }

    new p5(sketch)
  }
}
